/**
 * allSettled plugin for JQuery.Defferred
 */
define('common/allSettled',['jquery', 'lodash'],
    function($, _) {
        'use strict';
        /**
         * function to check weather all promises has been promised or not.
         * Unlike when all promises will be processed irrespective if any
         * one of then fails or not. If any of them failed, then the
         * promise given by this function is rejected
         *
         * @param  {$.promise []}     promises array of promises to watch
         * @return {promise}          promise of calling functions
         */
        $.allSettled = function(promises) {
            var deferred = $.Deferred(), success = 0, failure = 0, responses = [];
            _.forEach(promises, function(promise, index) {
                promise.done(function(result) {
                    success++;
                    responses[index] = result;
                    checkStatus();
                }).fail(function(result) {
                    failure++;
                    responses[index] = result;
                    checkStatus();
                });
            });
            return deferred;
            
            /**
             * Function to check the status of deferred process
             * @return {undefined}
             */
            function checkStatus() {
                if (success + failure === promises.length) {
                    if(failure) {
                        deferred.reject.apply(promises, responses);
                    } else {
                        deferred.resolve.apply(promises, responses);
                    }
                }
            }
        };
        return $;
    });
